export default [
  {
    path: '/study-planner',
    name: 'studyPlanner#show',
    component: () => import(/* webpackChunkName: "studyPlanner/show" */ '@views/study-planner/show'),
    meta: {
      header: true,
      resourceOptional: true,
    },
  },
];
